// extracted by mini-css-extract-plugin
export default {"social":"cS1HGy_Bq","pull":"chPghEeRH"};